import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import * as moment from 'moment';
import { ApiService } from '../../../../../services/api.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DocumentIssueForm } from '../../document-issue.model';
import Decimal from 'decimal.js-light';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-document-issue-form',
  templateUrl: './document-issue-form.component.html',
  styleUrls: ['./document-issue-form.component.scss']
})
export class DocumentIssueFormComponent implements OnInit {
  @Input() buyerBranchID: string;
  @Input() document: any;

  @Output() data = new EventEmitter();

  username = localStorage.getItem('username');

  documentIssueForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.createDocumentIssueForm();
  }

  get currentLang(): string {
    return this.translateService.currentLang;
  }

  submit() {
    if (this.documentIssueForm.valid) {
      const documentIssue: DocumentIssueForm = this.documentIssueForm.value;
      const seller = documentIssue.sellerForm;
      const document = documentIssue.documentForm;
      const buyer = documentIssue.buyerForm;
      const lineItem = documentIssue.lineItemForm;

      if (lineItem.correctAmount.includes('-')) {
        return;
      }

      const data = {
        file_type: this.document.type || '',
        document_number: document.runningNo || '',
        branch_code: seller.branchCode || '',
        branch_name: seller.branchName || '',
        invoice_number: document.documentNo || '',
        issue_dt: moment(document.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss'),
        purpose: document.purpose || '',
        abb_no: document.abbNo || '',
        confirmation_no: document.confirmationNo || '',
        document_request_id: document.documentRequest,
        order_no: document.orderNo || '',
        reference: document.referenceDocuments.map((referenceDocument) =>
        ({
          ref_date: referenceDocument.documentDate ? moment(referenceDocument.documentDate).format('YYYY-MM-DD') + 'T' + moment().startOf('day').format('HH:mm:ss') : '',
          ref_doc_no: referenceDocument.documentNo || '',
          ref_doc_type: referenceDocument.documentType || ''
        })),
        seller: {
          name_th: seller.name || '',
          name_en: seller.nameEN || '',
          tax_id: seller.taxID || '',
          address_th: seller.address || '',
          address_en: seller.addressEN || '',
          post_code: seller.postalCode || '',
        },
        buyer: {
          name: buyer.name || '',
          tax_id: buyer.taxID || '',
          branch_code: buyer.branchCode || '',
          branch_name: buyer.branchName || '',
          address: buyer.address || '',
          post_code: buyer.postalCode || '',
          country_code: buyer.country || '',
          email: buyer.email || '',
          cc_email: buyer.ccEmail || ''
        },
        line_items: lineItem.items.map((item, index) => ({
          item_number: String(index + 1),
          product_id: item.productID || '',
          product_name: item.description || '',
          quantity: item.quantity || '0',
          unit: item.unit || '',
          unit_price: item.unitPrice || '0',
          net_discount_or_charge: item.discount || '0',
          net_total_amount: item.total,
          line_vat: item.lineVAT || '0'
        })),
        total_items: {
          line_total_amount: (new Decimal(lineItem.subTotal).minus(new Decimal(lineItem.discountTotal))).toFixed(2),
          line_total_amount_after_discount: lineItem.balance,
          percent_vat: lineItem.percentVAT || '',
          vat: lineItem.vat,
          non_vat_amount: lineItem.nonVATAmount,
          vat_0_amount: lineItem.vat0Amount,
          vat_amount: lineItem.vatAmount,
          total_payment: lineItem.netTotal,
          discount_or_charge: lineItem.endOfBillDiscount || '0',
          discount_or_charge_reason: lineItem.discountReason || '',
          original_amount_before_vat: lineItem.originalAmount || '',
          original_amount_vat: lineItem.originalVAT || '',
          correct_amount: lineItem.correctAmount || '',
          difference_amount: lineItem.balance || '',
        }
      };

      this.data.emit(data);
    }
  }

  createDocumentIssueForm() {
    this.documentIssueForm = this.formBuilder.group({
      sellerForm: [],
      documentForm: [],
      buyerForm: [],
      lineItemForm: []
    }, { asyncValidator: this.documentNoValidator });
  }

  documentNoValidator: AsyncValidatorFn = (control: FormGroup): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const sellerForm = control.get('sellerForm');
    const documentForm = control.get('documentForm');

    const sellerTaxID = sellerForm.value ? sellerForm.value['taxID'] : null;
    const documentNo = documentForm.value ? documentForm.value['documentNo'] : null;

    const params = {
      seller_tax_id: sellerTaxID,
      document_no: documentNo
    };

    return timer(300).pipe(
      switchMap(() => {
        return this.apiService.checkMatchedInvoiceNumber(params).pipe(
          map((res: any) => (res.duplicate ? { duplicateDocumentNo: { value: 'Duplicate Document Number' } } : null)),
          catchError(() => of(null))
        );
      })
    );
  };

  onDocumentRequestSelected(event) {
    const buyerForm = this.documentIssueForm.get('buyerForm') as FormGroup;
    buyerForm.patchValue({
      name: event ? event.buyer_name : null,
      taxID: event ? event.tax_id : null,
      branchCode: event ? event.branch_code : null,
      branchName: event ? event.branch_code : null,
      address: event ? event.address : null,
      postalCode: event ? event.postal_code : null,
      country: event ? event.country_code : null,
      email: event ? event.email : null,
      ccEmail: event ? event.cc_email : null,
    })
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.component.ts